import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchPeDealDetailQuery } from 'rtkQuery/sharespro/queries/peService';

import PeCompanyDataView from 'presentation/components/modules/pe/shared/detail/PeCompanyDataView';

const PeDealDetailPage: FC = () => {
  const { id } = useParams();
  const { isFetching, data, refetch, error } = useFetchPeDealDetailQuery({
    id: +(id as string),
  });

  return (
    <PeCompanyDataView
    assetId={+(id as string)}
      data={data?.company}
      refetch={() => {
        refetch();
      }}
      error={error}
      isFetching={isFetching}
    />
  );
};

export default PeDealDetailPage;
